<template>
    <div class="inner-wrapper">
   <!--<div class="page-title">
      <h1 class="float-left">Products</h1>
      <div class="title-right float-right">
      </div>
   </div>-->
      <div class="new-rfq">
      <div class="alert alert-success succ_msg" v-if="successMessage !=null">
            <strong class="success_msg">{{successMessage}}</strong>
        </div>
      <fieldset class="customer-search mb-3">
               <div class="row">
                    <div class="col-sm-12 col-md-12">
                        <form class="form-inline report-form" action="">

                            <div class="form-group">
                                
                                
                                <select class="form-control"  v-model="filterForm.transaction_type">
                                    <option value="">Select Transaction Type</option>
                                    <option value="so">Sales Order</option>
                                    <option value="po">Purchase Order</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <input class="form-control" v-model="filterForm.order_number" type="text" placeholder="Order Number" >
                            </div>
                            <!--<div class="form-group number-select" v-if="customer_disable">
                                <div class="listsearch-box">
                                <v-select label="order_number" taggable  placeholder="Order Number"    v-model="filterForm.order_number" :filterable="true" :options="optionOrderNumber" :reduce="(option) => option.order_number" @search="onSearchOrderNumber">
                                    <template slot="no-options">
                                    Search
                                    </template>
                                    <template slot="option" slot-scope="option">
                                    <div class="d-center">
                                        {{ option.order_number }}
                                        </div>
                                    </template>
                                    <template slot="selected-option" slot-scope="option">
                                    <div class="selected d-center">
                                        {{ option.order_number }}
                                    </div>
                                    </template>
                                </v-select>
                                </div>
                            </div>

                            <div class="form-group number-select" v-if="vendor_disable">
                                <div class="listsearch-box">
                                <v-select label="po_number" taggable  placeholder="Order Number"    v-model="filterForm.order_number" :filterable="true" :options="optionOrderNumber" :reduce="(option) => option.po_number" @search="onSearchOrderNumber">
                                    <template slot="no-options">
                                    Search
                                    </template>
                                    <template slot="option" slot-scope="option">
                                    <div class="d-center">
                                        {{ option.po_number }}
                                        </div>
                                    </template>
                                    <template slot="selected-option" slot-scope="option">
                                    <div class="selected d-center">
                                        {{ option.po_number }}
                                    </div>
                                    </template>
                                </v-select>
                                </div>
                            </div> -->
                            
                            <div class="input-group quick-search" v-if="customer_disable">
                                <div class="listsearch-box">
                                    
                                    <v-select label="company_name" placeholder="Select Customer" v-model="filterForm.customer_id" :filterable="false" :options="options" :reduce="(option) => option.id" @search="onSearch">
                                        <template slot="no-options">
                                        Search Customer
                                        </template>
                                        <template slot="option" slot-scope="option">
                                        <div class="d-center">
                                            {{ option.company_name }}
                                            </div>
                                        </template>
                                        <template slot="selected-option" slot-scope="option">
                                        <div class="selected d-center">
                                            {{ option.company_name }}
                                        </div>
                                        </template>
                                    </v-select>
                                </div>
                            </div>

                            <div class="input-group quick-search" v-if="vendor_disable">
                                <div class="listsearch-box">
                                    
                                    <v-select label="company_name" placeholder="Select Vendor" v-model="filterForm.vendor_id" :filterable="false" :options="optionsVendor" :reduce="(option) => option.id" @search="onVendorSearch">
                                        <template slot="no-options">
                                        Search Vendor
                                        </template>
                                        <template slot="option" slot-scope="option">
                                        <div class="d-center">
                                            {{ option.company_name }}
                                            </div>
                                        </template>
                                        <template slot="selected-option" slot-scope="option">
                                        <div class="selected d-center">
                                            {{ option.company_name }}
                                        </div>
                                        </template>
                                    </v-select>
                                </div>
                            </div>

                            <div class="form-group">
                                <select class="form-control" v-model="filterData.search_by_date" @change="searchDate()">
                                    <option :value="null">Time Frame</option>
                                    <option value="0">All Time</option>
                                    <option value="1">Today</option>
                                    <option value="2">This week</option>
                                    <option value="3">This Month</option>
                                    <option value="4"> This Year</option>
                                    <option value="5">Custom Range</option>
                                </select>
                            </div>
                            <div class="form-group" v-if="showFilters">
                                
                                    <date-picker v-if="filterData.search_by_date == 5" format="MM/DD/YYYY" @change="searchDate()"
                                                v-model="filterData.date_range" range></date-picker>
                                
                            </div>
                            <div class="search-btnsec dl-flex">
                                <template v-if="customer_disable">
                                    <button class="btn btn-success" type="button"  @keypress.enter.prevent="filterSearch" @click="filterSearch" ><i class="ri-search-line search-icon"></i>
                                    </button>
                                    <button class="btn btn-reset" type="button" @click="resetFilter"><i class="ri-refresh-line"></i>
                                    </button>
                                    <button class="btn btn-file" type="button" @click="download"><i class="ri-file-pdf-line"></i>
                                    </button>
                                    <button v-if="disableExcel" class="btn btn-file" type="button"  @click="downloadExcel"><i class="ri-file-excel-line"></i>
                                    </button>
                                    <button v-if="downloadFinal" class="btn btn-file" type="button"  @click="downloadExcelById"><i class="ri-file-excel-line"></i>
                                    </button>
                                </template>
                                
                                <template  v-if="vendor_disable">
                                <button class="btn btn-success" type="button"  @keypress.enter.prevent="filterSearch" @click="filterSearch" ><i class="ri-search-line search-icon"></i>
                                    </button>
                                    <button class="btn btn-reset" type="button" @click="resetFilter"><i class="ri-refresh-line"></i>
                                    </button>
                                    <button class="btn btn-file" type="button" @click="downloadPo"><i class="ri-file-pdf-line"></i>
                                    </button>
                                    <button  class="btn btn-file" type="button"  @click="downloadExcelPo"><i class="ri-file-excel-line"></i>
                                    </button>
                                </template>

                                
                            </div>
                             
                        </form>
                    </div>
                    
               </div>
            </fieldset>
            <!-- The Modal -->
      </div>
        <template v-if="customer_disable">
            <ProductList  ref="ProductList" :bus="bus" :search_by_date="filterData.search_by_date" :date_range="filterData.date_range" :order_number="filterForm.order_number" :status_filter="filterForm.status_filter" :customer_filter="filterForm.customer_id" :vendor_filter="filterForm.vendor_id" ></ProductList>
        </template>
        
        <template v-if="vendor_disable">
            <ReportListPO   ref="ReportListPO" :bus="bus" :search_by_date="filterData.search_by_date" :date_range="filterData.date_range" :order_number="filterForm.order_number" :status_filter="filterForm.status_filter" :customer_filter="filterForm.customer_id" :vendor_filter="filterForm.vendor_id" ></ReportListPO>
        </template>

        
      <!-- Delete Modal HTML -->
        <footer class="footer">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-sm-6">
                        2022 © Superb.
                    </div>
                    <div class="col-sm-6">
                        <div class="text-right d-none d-sm-block">
                            All Rights Reserved.
                        </div>
                    </div>
                </div>
            </div>
        </footer>
   
</div>
</template>
<script>
import {mapState, mapActions, mapGetters} from 'vuex';
import axios from "axios";
import Vue from "vue";
import ProductList from "../../components/ReportList";
import ReportListPO from "../../components/ReportListPO";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
export default {
    name: "CustomerList",
    components: {
        DatePicker,ProductList,ReportListPO
    },
    created() {
         if(localStorage.getItem('token')){
             console.log("token "+localStorage.getItem('token'));
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
        }
        this.setSuccessMessage(null);
        //this.getCustomers();
    },
    data(){
        return {
            optionsFound:[],
            optionOrderNumber:[],
            customer_disable:true,
            vendor_disable:false,
            showFilters: true,
            disableExcel:true,
            downloadFinal:false,
            disableFinal:true,
            selected: '2',
            selectedAjax: '-1',
            options: [{ id: 1, text: 'Hello' }, { id: 2, text: 'World' }],
            optionsAjax: [{ id: -1, text: '' }],
            bus: new Vue(),
            selected:[],
            optionsVendor:[],
            options:[
                        // { label: 'Select More Column', id: 0 },
                        // { label: 'General phone number', id: 1 },
                        // { label: 'Billing email', id: 2 },
                        // { label: 'Total number of quotes', id: 3 },
                        // { label: 'Total number of orders', id: 4 },
                    ],
            customerData: {
                customers: {
                    data:[]
                },
                config: null,
                can_add_customer: false,
                can_edit_customer: false,
                can_delete_customer: false,
                user_type: null,
                role: null,

            },
            current_page:1,
            per_page:10,
            total:0,
            filterForm: {
                transaction_type:'so',
                search_filter: null,
                status_filter: '',
                customer_id:null,
                vendor_id:null,
                order_number:null
            },
            filterData: {
                purchase_search: null,
                search_saleuser_id: null,
                search_vendor_id: null,
                search_added_user_id: null,
                search_by_date: "5",
                search_status_Id: null,
                date_range: null
            },
            showModal: false,
            deleteId: null,
            csv_file: null,
            uploadPercent: 0,
            showUploadProgress: false,
            processingUpload: false
        }
    },
    methods: {
        ...mapActions([
            'setCommonErrors',
            'setErrorMessage',
            'setSuccessMessage',
            'setCustomers',
            'setCustomerLoading',
            'setLoading',
            'setExportFile'
        ]),
         resetFilter() {
            // this.filterData = {
            //     purchase_search: null,
            //     search_saleuser_id: null,
            //     search_vendor_id: null,
            //     search_added_user_id: null,
            //     search_by_date: null,
            //     search_status_Id: null,
            //     date_range: null
            // };
            this.filterForm = {
                search_filter: null,
                status_filter: '',
                customer_id:null,
                vendor_id:null,
                order_number:null
            };
           // this.setPurchaseOrdersFilterData(this.filterData);
            this.vendor = null;
            //this.search();
        },
        filterSearch() {
            
            if(this.filterForm.transaction_type != ''){

                if(this.filterForm.transaction_type == 'so'){
                    this.bus.$emit('getCustomers')
                }
                else{
                    this.bus.$emit('getCustomersPo')
                }
                
            }
            else{
                this.$bvToast.toast('Please Select Transaction Type', {
                        title: 'Please Select Transaction Type',
                        autoHideDelay: 60000,
                        appendToast: true,
                        variant: 'success',
                        solid: true,
                        toaster: 'b-toaster-top-right'
                    });
            }
                
            
        },
        onSearch(search, loading) {
            if(search.length) {
                loading(true);
                this.search(loading, search, this);
            }
        },
        onVendorSearch(search, loading) {
            if(search.length) {
                loading(true);
                this.searchVendor(loading, search, this);
            }
        },
        searchDate() {
            this.showFilters = true;
            //this.bus.$emit('getOrders')
        },
        searchVendor(loading, search, vm) {
            
            let self = this;
            this.setCustomerLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(window.route('vendors.search',{search: search} ), {

                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
            .then(({ data }) => {
                console.log("DATA ",data);
                if(data.errors){
                    console.log("error ",data);
                    self.setCommonErrors(data.errors);
                } else if(data.errorMessage){
                    self.setErrorMessage(data.errorMessage);
                } else {
                    let customer = [];
                    let allData =  data.data.data
                    console.log("Length",allData,allData.length);
                    vm.optionsVendor = data.data.data;

                   loading(false);

                }
            })
            .catch((error) => {
                self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

            })
            .finally(() => {
                self.setCustomerLoading(false);

            });
        },
        onSearchOrderNumber(search, loading) {
            if(search.length) {
                loading(true);
                
                //console.log("this.optionOrderNumber ",this.optionOrderNumber)
                if(this.filterForm.transaction_type == 'so'){
                    this.searchOrderNumber(loading, search, this);
                }
                else if(this.filterForm.transaction_type == 'po'){
                    this.searchOrderNumberPo(loading, search, this);
                }
                else{
                   
                }
                
            }
        },
         searchOrderNumber(loading, search, vm) {
            
          // console.log("searchOrderNumber ",vm.optionOrderNumber);
            // fetch(
            //     `https://api.github.com/search/repositories?q=${escape(search)}`
            // ).then(res => {
            //     res.json().then(json => (vm.options = json.items));
            //     loading(false);
            // });

            let self = this;
            this.setCustomerLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(window.route('so.searchOrderNo',{search: search} ), {

                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
            .then(({ data }) => {
               
                if(data.errors){
                    
                    self.setCommonErrors(data.errors);
                } else if(data.errorMessage){
                    self.setErrorMessage(data.errorMessage);
                } else {
                    let customer = [];
                    let allData =  data.data.data
                    vm.optionOrderNumber = data.data.data;
                    console.log("oder nmber ",data.data.data);

                   loading(false);

                }
            })
            .catch((error) => {
                self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

            })
            .finally(() => {
                self.setCustomerLoading(false);

            });
        },
        searchOrderNumberPo(loading, search, vm) {
            //console.log("searchOrderNumberPo ",vm.optionOrderNumber);
            let self = this;
            this.setCustomerLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(window.route('po.searchOrderNo',{search: search} ), {

                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
            .then(({ data }) => {
               
                if(data.errors){
                    
                    self.setCommonErrors(data.errors);
                } else if(data.errorMessage){
                    self.setErrorMessage(data.errorMessage);
                } else {
                    let customer = [];
                    let allData =  data.data.data
                    vm.optionOrderNumber = data.data.data;
                    console.log("oder nmber ",data.data.data);
                    loading(false);

                }
            })
            .catch((error) => {
                self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

            })
            .finally(() => {
                self.setCustomerLoading(false);

            });
        },
        search(loading, search, vm) {
            // fetch(
            //     `https://api.github.com/search/repositories?q=${escape(search)}`
            // ).then(res => {
            //     res.json().then(json => (vm.options = json.items));
            //     loading(false);
            // });

            let self = this;
            this.setCustomerLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(window.route('customers.search',{search: search} ), {

                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
            .then(({ data }) => {
                console.log("DATA ",data);
                if(data.errors){
                    console.log("error ",data);
                    self.setCommonErrors(data.errors);
                } else if(data.errorMessage){
                    self.setErrorMessage(data.errorMessage);
                } else {
                    let customer = [];
                    let allData =  data.data.data
                    console.log("Length",allData,allData.length);
                    vm.options = data.data.data;

                   loading(false);

                }
            })
            .catch((error) => {
                self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

            })
            .finally(() => {
                self.setCustomerLoading(false);

            });
        },

        download(d) {
            let url = window.route('so.getPdfReports', {
                //id: 7768
                order_number: this.filterForm.order_number,
                //search_filter:this.filterForm.search_filter,
                //status_filter:this.filterForm.status_filter,
                customer_filter:this.filterForm.customer_id,
                vendor_filter:this.filterForm.vendor_id,
                search_by_date:this.filterData.search_by_date,
                date_range:this.filterForm.date_range
            });

            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(url, {
                responseType: "blob",
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    self.setLoading(false);
                    // Service that handles ajax call
                    // const url = window.URL.createObjectURL(new Blob([data]));
                    // const link = document.createElement("a");
                    // link.href = url;
                    // link.setAttribute("target", "_blank");
                    // link.setAttribute("download", url);
                    // document.body.appendChild(link);
                    // link.click();
                    // link.remove();
                    const url = window.URL.createObjectURL(new Blob([data]));
                    const link = document.createElement("a");
                    let fileName = 'Sales-reports-'+Math.floor(100000 + Math.random() * 900000)+'.pdf';
                    
                    link.href = url;
                    link.setAttribute("target", "_blank");
                    link.setAttribute("download", fileName);
                    document.body.appendChild(link);
                    link.click();
                    link.remove();

                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        downloadPo(d) {
            let url = window.route('po.getPdfReports', {
                order_number: this.filterForm.order_number,
                vendor_filter:this.filterForm.vendor_id,
                search_by_date:this.filterData.search_by_date,
                date_range:this.filterForm.date_range
            });

            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(url, {
                responseType: "blob",
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    self.setLoading(false);
                    const url = window.URL.createObjectURL(new Blob([data]));
                    const link = document.createElement("a");
                    let fileName = 'Purchase-reports-'+Math.floor(100000 + Math.random() * 900000)+'.pdf';
                    link.href = url;
                    link.setAttribute("target", "_blank");
                    link.setAttribute("download", fileName);
                    document.body.appendChild(link);
                    link.click();
                    link.remove();

                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        downloadExcelById(d) {
            console.log("exportFile",this.exportFile);
            
            let url = window.route('so.downloadReport', {
                id: this.exportFile.id
            });

            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(url, {
                responseType: "blob",
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    self.setLoading(false);
                    // Service that handles ajax call
                    // const url = window.URL.createObjectURL(new Blob([data]));
                    // const link = document.createElement("a");
                    // link.href = url;
                    // link.setAttribute("target", "_blank");
                    // link.setAttribute("download", url);
                    // document.body.appendChild(link);
                    // link.click();
                    // link.remove();
                    const url = window.URL.createObjectURL(new Blob([data]));
                    const link = document.createElement("a");
                    let fileName = 'Sales-reports-'+Math.floor(100000 + Math.random() * 900000)+'.xls';
                    
                    link.href = url;
                    link.setAttribute("target", "_blank");
                    link.setAttribute("download", fileName);
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    // self.disableExcel = true;
                    // self.downloadFinal = false;
                    // self.disableFinal = true;

                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        downloadExcel(d) {
            let url = window.route('so.getExcels', {
                //id: 7768
                order_number: this.filterForm.order_number,
                //search_filter:this.filterForm.search_filter,
                //status_filter:this.filterForm.status_filter,
                customer_filter:this.filterForm.customer_id,
                vendor_filter:this.filterForm.vendor_id,
                search_by_date:this.filterData.search_by_date,
                date_range:this.filterForm.date_range,
                download:1
            });

            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(url, {
                responseType: "blob",
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    self.setExportFile(null);
                    self.setLoading(false);
                    const url = window.URL.createObjectURL(new Blob([data]));
                    const link = document.createElement("a");
                    let fileName = 'Sales-reports-'+Math.floor(100000 + Math.random() * 900000)+'.xlsx';
                    
                    link.href = url;
                    link.setAttribute("target", "_blank");
                    link.setAttribute("download", fileName);
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    // self.disableExcel = false;
                    // self.downloadFinal = true;
                    
                    // //console.log("success",data);
                    // //self.setSuccessMessage(data.data);
                    //  self.$bvToast.toast(data.data, {
                    //     title: data.data,
                    //     autoHideDelay: 60000,
                    //     appendToast: true,
                    //     variant: 'success',
                    //     solid: true,
                    //     toaster: 'b-toaster-top-right'
                    // });
                   

                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        downloadExcelPo(d) {
            let url = window.route('po.getExcels', {
                order_number: this.filterForm.order_number,
                vendor_filter:this.filterForm.vendor_id,
                search_by_date:this.filterData.search_by_date,
                date_range:this.filterForm.date_range,
                download:1
            });

            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(url, {
                responseType: "blob",
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    self.setExportFile(null);
                    self.setLoading(false);
                    const url = window.URL.createObjectURL(new Blob([data]));
                    const link = document.createElement("a");
                    let fileName = 'Sales-reports-'+Math.floor(100000 + Math.random() * 900000)+'.xlsx';
                    
                    link.href = url;
                    link.setAttribute("target", "_blank");
                    link.setAttribute("download", fileName);
                    document.body.appendChild(link);
                    link.click();
                    link.remove();                 

                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
    },

    mounted: function() {
            let self = this; 
            window.addEventListener('keyup', function(ev) {
                if(ev.keyCode == 13){

                    if(self.filterForm.transaction_type != ''){
                        self.bus.$emit('getCustomers')
                    }
                    else{
                        self.$bvToast.toast('Please Select Transaction Type', {
                                title: 'Please Select Transaction Type',
                                autoHideDelay: 60000,
                                appendToast: true,
                                variant: 'danger',
                                solid: true,
                                toaster: 'b-toaster-top-right'
                            });
                    }

                    
                }
            });         

        },
    
    watch: {

        exportFile: {
            handler: function(value) {
                
                console.log("watch ",value);

            }
        },
        "filterForm.transaction_type": {
            handler: function(value) {
                
                if(value == 'po'){
                    this.optionOrderNumber.length = 0;
                    this.customer_disable = false;
                    this.vendor_disable = true;
                }
                else if(value == 'so'){
                    this.optionOrderNumber.length = 0;
                    this.customer_disable = true;
                    this.vendor_disable = false;
                }
                else{
                    // this.customer_disable = false;
                    // this.vendor_disable = false;
                }
                console.log("transaction_type ",this.vendor_disable);
            }
        },
    },
    computed: {
        ...mapState([
            'userState'
        ]),
        ...mapGetters([
            'isAuth',
            'getAuthUser',
            'commonErrors',
            'errorMessage',
            'successMessage',
            'customers',
            'customersLoading',
            'exportFile'
        ])
    }
}
</script>

<style scoped>
#app {
		font-family: 'Avenir', Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		text-align: center;
		color: #2c3e50;
		margin-top: 60px;
	}
	.select2-selection {
		border-radius: 0px !important;
		text-align: left !important;
	}
	.select2-dropdown {
		border-radius: 0px !important;
	}
</style>

